import { useEffect } from "react";
// useLocation hook: to get current URL info.
// useNavigate hook: for URL redirection.
import { useAuth } from "react-oidc-context";
import { useLocation, useNavigate } from "react-router-dom";

// UseAuth: to handle authentication with AWS Cognito.
import pheonixLogo from "../../assets/styles/branding/phoenix-logo.svg";
import { AuthState } from "../../types/auth.types";
import Button from "../layout/Button";

interface LocationState {
  from?: { pathname: string; search: string; hash: string };
}

const LoginPortal = () => {
  // The return value of useAuth is of TS type 'AuthState'.
  const auth = useAuth() as AuthState;
  // Extract the current URL path location.
  const location = useLocation();
  // Redirect the user to the desired URL path after a successful login.
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      // location.state has the protected URL the user was trying to access.
      // Reconstruct pathname + search + hash (not just pathname) so query
      // params - e.g. Calls Explorer filters in the URL - survive the
      // login redirect instead of being silently dropped.
      const from = (location.state as LocationState | null)?.from;
      const target = from ? `${from.pathname}${from.search}${from.hash}` : "/dashboard";
      navigate(target, { replace: true });
    }
  }, [auth.isAuthenticated, location.state, navigate]);

  return (
    <div className="login-portal d-flex flex-column justify-content-center align-items-center vh-100">
      <img src={pheonixLogo} alt="Logo" className="phoenix-logo" />
      {/* auth.signInRedirect comes from react-oidc-context */}
      {/* It builds the AWS cognito URL using the values from auth.config.ts */}
      {/* On click, the button redirects the user to the AWS Cognito login page. */}
      <Button
        testId="login-portal-submit"
        onClick={() => {
          auth.signinRedirect();
        }}
      >
        Login to continue
      </Button>
    </div>
  );
};

export default LoginPortal;
